/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Link } from 'bold-ui'
import { RouterLink } from 'components/route/RouterLink'

export interface AcompanhamentoHeaderLinkProps {
  title: string
  path: string
}

export function AcompanhamentoHeaderLink(props: Readonly<AcompanhamentoHeaderLinkProps>) {
  const { title, path } = props

  return (
    <Link component={RouterLink} to={path} textDecoration='none' fontSize={0.875} style={styles.headerLink}>
      {title}
    </Link>
  )
}

const styles = {
  headerLink: css`
    line-height: 1.8;
  `,
}
